import { useEffect } from 'react'
import {
  useSignInVerifyAuthenticationCodeMutation,
  useSignInCreateAuthenticationCodeMutation,
} from 'graphql/types'
import logger from 'lib/logger'
import { setJwt } from 'lib/user'

const useAuth = () => {
  const [
    createAuthenticationCode,
    {
      data: dataCreate,
      error: errorCreate,
      loading: loadingCreate,
      client: apolloClient,
    },
  ] = useSignInCreateAuthenticationCodeMutation()

  const [
    verifyAuthenticationCode,
    { data: dataCode, error: errorCode, loading: loadingCode },
  ] = useSignInVerifyAuthenticationCodeMutation()

  const codeCreatedSuccessfully =
    dataCreate?.signInCreateAuthenticationCode?.enqueued === 'SUCCESS'

  const authenticationJwtCode = dataCode?.signInVerifyAuthenticationCode?.jwt

  const clearApolloStore = async () => {
    await apolloClient.resetStore().catch((e) => {
      logger.capture(e)
    })
  }

  useEffect(() => {
    if (authenticationJwtCode) {
      try {
        setJwt(authenticationJwtCode)
        void clearApolloStore()
      } catch (e) {
        logger.action('site-cookie-error', { error: e })
        logger.capture(e)
      }
    }
  }, [authenticationJwtCode])

  return {
    createAuthenticationCode,
    verifyAuthenticationCode,
    hasErrorCreateCode: errorCreate,
    hasErrorVerifyCode: errorCode,
    hasError: errorCode || errorCreate,
    isLoading: loadingCode || loadingCreate,
    codeCreatedSuccessfully,
    authenticationJwtCode,
  }
}

export default useAuth
